/**
   * *****************************************
   * PERSIST departure and wind values
   * 'navlog_globals_v1' is the key value used in LocalStorage
   * to store the global variables as a JSON string.  
   * When the component mounts, it retrieves the saved values 
   * and updates the state accordingly.
   * 
   * 'g' is an object that contains all the global variables
   * ***************************************
   */
import { useEffect } from "react";

function useWcaPersistence({
  forecastTerminals,
  setForecastTerminals,
  windsRegion,
  setWindsRegion,
  windsFcst,
  setWindsFcst,
  setInitialized,
}) {
  // LOAD
  useEffect(() => {
    const saved = localStorage.getItem("navlog_globals_v1");

    if (!saved) {
      setInitialized(true);
      return;
    }

    try {
      const g = JSON.parse(saved);

      if (g.windsRegion != null) setWindsRegion(String(g.windsRegion));
      if (g.windsFcst != null) setWindsFcst(String(g.windsFcst));

      if (
        Array.isArray(g.forecastTerminals) &&
        g.forecastTerminals.length === 2
      ) {
        setForecastTerminals(g.forecastTerminals);
      }
    } catch (e) {
      // ignore bad JSON
    }

    setInitialized(true);
  }, []);

  // SAVE
  useEffect(() => {
    const g = {
      forecastTerminals,
      windsRegion,
      windsFcst,
    };

    localStorage.setItem("navlog_globals_v1", JSON.stringify(g));
  }, [forecastTerminals, windsRegion, windsFcst]);
}

export default useWcaPersistence;